<wuc-list>
    <wuc-list-item *ngFor="let coverage of coverages">{{ coverage?.coverageDescription }}</wuc-list-item>
</wuc-list>
